module.exports = require('./helpers/bundle-url').getBundleURL('bu0dN') + "f35796a06df51_002.d0f8105c.png";